import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { ClientsFilterService } from 'src/app/services/clients-filter.service';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { ProfileService } from 'src/app/services/profile.service';
import { TokenExpireService } from 'src/app/services/token-expire.service';
import { IsValidArray } from 'src/app/validation';
import { isNullOrUndefined } from '../../validation';
declare var $: any;

@Component({
  selector: 'app-get-filter-data',
  templateUrl: './get-filter-data.component.html',
  styleUrls: ['./get-filter-data.component.scss']
})
export class GetFilterDataComponent {
  @Output() FilterData: EventEmitter<any> = new EventEmitter();
  @Input() isMultiSelect: boolean = false;
  @Input() DDLFilterType: string = 'T';    // Default 'T' is passed -- Added by Saddam
  @Input() HierarchyClient = true;
  @Input() FilterType: string = "byClient"; // i have changed simple FilterType to @Input type
  @Input() SetDefaultClientByID: string = '';
  @Input() IsSelf: boolean = false;
  clientFilterForm: FormGroup;
  LoginId: string;
  UserType: string = "";
  Param1: string = "";
  ClientData: any;
  TempClientData: any;
  FamilyData: any;
  EmployeeData: any;
  EmployeeDataH: any;
  EmployeeSetting = {};
  SelectedEmployee: any;
  SubbrokerData: any;
  HierarchyData: any;
  PlaceData: any;
  PlaceDataALL: any;
  ResponseData: any;
  selectedClient: any;
  @Input() isShowClientFilter: boolean = true;
  isdisplayFamilyName: boolean = true;
  isDisplayClientName: boolean = true;

  @Input() isShowEmpSubBrokerFilter: boolean = true;

  isDisplayEmployeeName: boolean = true;
  isDisplaySubBrokerName: boolean = true;
  isDisplayEmpSubBrokerFamilyName: boolean = true;
  isDisplayEmpSubClientName: boolean = true;

  isShowHiearchyFilter: boolean = true;
  IsShowSubbroker: boolean = true;
  ClientDataSetting = {};
  resultDisplayName = [];
  AllEmpData = [];
  result = [];
  selectedItems: any[] = [];
  ChildSubbrokerData: any[] = [];
  IsMobile: boolean = false;
  @Input() CheckUCCForTranx: boolean = false;
  G_ROLEID: number;
  ClientData_Temp: any;  //Added by Saddam : Store ClientData on page load
  FamilData_Temp: any;    //Added by Saddam
  IsHeirarchyEmp: boolean = false;    //Added by Saddam
  CorpIFDFlag: string = '';
  @Input() DashboardUserId: string = '';     //Dashboard UserId
  @Input() DashboardUserType: string = '';     //Dashboard UserId
  // @Input() DashboardUserType: string = '';   //Dashboard DashboardUserType
  constructor(
    private fb: FormBuilder,
    private encryptDecrypt: EncrdecrService,
    private ClientFilterService: ClientsFilterService,
    private Loader: CustomLoaderService,
    private Logout: TokenExpireService,
    private EncrdecrService: EncrdecrService,
    private ProfileService: ProfileService,) {
    this.clientFilterForm = this.fb.group({
      ClientBasicInfoId: [''],
      FamilyId: [''],
      EmpId: [''],
      SubbrokerId: [''],
      HierarchyId: [''],
      PlaceId: ['']
    });
  }

  ngOnInit() {
    this.BindDropdown();
  }

  BindDropdown() {
    debugger
    this.Loader.show();

    this.LoginId = this.DashboardUserId;
    this.UserType = this.DashboardUserType;

    let request = {
      "LoginId": this.LoginId,
      "LoginType": this.UserType,
      "FilterType": this.DDLFilterType,
      "Param1": this.Param1,
      "Param2": this.IsSelf ? "self" : ""
    }

    let body = { data: this.encryptDecrypt.setEncr(JSON.stringify(request)) }
    this.ClientFilterService.WrapperApiCall(body, "/api/ClientFilters/getClientFilters").then(
      (response: any) => {
        debugger
        let res = JSON.parse(this.EncrdecrService.getDecr(response))
        this.ResponseData = res;
        //console.log(res)
        if (res.code == 200) {
          console.log(res);

          if (IsValidArray(res.ArrayOfResponse[0].ClientDetails)) {
            debugger
            this.ClientData = res.ArrayOfResponse[0].ClientDetails;
            this.TempClientData = res.ArrayOfResponse[0].ClientDetails;
            this.ClientData_Temp = res.ArrayOfResponse[0].ClientDetails;
            let filterData = res.ArrayOfResponse[0].ClientDetails.filter(item => item.ClientGroupName !== null);
            this.FamilyData = [...new Set(filterData.map(item => item.ClientGroupName))];
            this.FamilData_Temp = this.FamilyData;
          }
          if (IsValidArray(res.ArrayOfResponse[0].SubbrokerDetails)) {
            this.SubbrokerData = res.ArrayOfResponse[0].SubbrokerDetails;
          }

          if (IsValidArray(res.ArrayOfResponse[0].EmployeeDetails)) {

            let filterData = res.ArrayOfResponse[0].EmployeeDetails.filter(item => item.ID_Code !== null);
            this.AllEmpData = filterData;
            this.EmployeeData = [...new Map(filterData.map(item => [item['ID_Code'], item])).values()]

            this.PlaceData = [...new Map(filterData.map(item => [item['PlaceName'], item])).values()]
            this.PlaceDataALL = this.PlaceData;

            this.HierarchyData = [...new Map(filterData.map(item => [item['HierarchyName'], item])).values()]
          }

          if (IsValidArray(res.ArrayOfResponse[0].ChildSubBrokers)) {
            this.ChildSubbrokerData = res.ArrayOfResponse[0].ChildSubBrokers;
          }

          // this.FilterData.emit(this.ClientData);
          this.onItemSelectDeselectAll(this.ClientData, 0)
          this.Loader.hide();
        }
      }, (err: any) => {
        this.Loader.hide();
        console.log(err);
      })

  }

  onItemSelectDeselectAll(items: any, para: number) {
    // this.ClearClientDetails();
    debugger
    let sb_id = [];
    try {
      switch (para) {
        case 0:
          this.result = [];
          this.resultDisplayName = [];
          // this.selectedItems=[];
          this.resultDisplayName.push('All');
          items.map(item => {
            this.result.push(item.ClientBasicInfoId);
          });
          break;
        case 1:
          this.result = [];
          this.resultDisplayName = [];
          this.selectedItems = [];
          break;
      }

      if (IsValidArray(this.SubbrokerData)) {
        try {
          this.SubbrokerData.map(item => {
            sb_id.push(item.SubbrokerId);
          })
        } catch (error) {
          console.log(error)
        }
      }

      let filterData = this.TempClientData;
      filterData[0].ClientID = this.result;
      filterData[0].flag = "Client";
      filterData[0].resultDisplayName = this.resultDisplayName;
      filterData[0].SubbrokerId = sb_id;
      console.log(filterData);
      this.FilterData.emit(filterData[0]);
    } catch (error) {
      this.Loader.hide();
      console.log(error)
    }

  }

}
